import styled from 'styled-components';
import {getColorFromTheme} from '../../../../../../../../../ui/ui-utils';

export const UpdateCardOverlay = styled.div`
  background: rgba(30, 30, 47, 0.48);
  inset: 0;
  position: fixed;
  z-index: 1200;
`;

export const UpdateCardSidecar = styled.form`
  background: ${getColorFromTheme('white')};
  box-shadow: -8px 0 32px rgba(30, 30, 47, 0.12);
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  position: fixed;
  right: 0;
  top: 0;
  width: min(560px, 100vw);
  z-index: 1201;
`;

export const UpdateCardHeader = styled.header`
  align-items: center;
  background: ${getColorFromTheme('white')};
  border-bottom: 1px solid ${getColorFromTheme('borderLight')};
  display: flex;
  flex: 0 0 auto;
  gap: 24px;
  justify-content: space-between;
  min-height: 80px;
  padding: 18px 24px;
`;

export const UpdateCardTitle = styled.h2`
  color: ${getColorFromTheme('blackTwo')};
  font: 600 20px/28px Graphik, sans-serif;
  margin: 0;
`;

export const UpdateCardCloseButton = styled.button`
  align-items: center;
  background: ${getColorFromTheme('white')};
  border: 1px solid ${getColorFromTheme('borderDark')};
  border-radius: 10px;
  color: ${getColorFromTheme('blackTwo')};
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 auto;
  font: 600 14px/22px Graphik, sans-serif;
  gap: 12px;
  height: 42px;
  justify-content: center;
  padding: 10px 16px;

  svg {
    height: 16px;
    width: 16px;
  }

  &:focus-visible {
    outline: 2px solid ${getColorFromTheme('purple300')};
    outline-offset: 2px;
  }

  &:disabled {
    color: ${getColorFromTheme('textMuted')};
    cursor: not-allowed;
  }
`;

export const UpdateCardBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 24px;
`;

export const UpdateCardIntro = styled.p`
  color: ${getColorFromTheme('textBody')};
  font: 400 14px/22px Graphik, sans-serif;
  margin: 0 0 20px;
`;

export const UpdateCardSection = styled.section`
  background: ${getColorFromTheme('white')};
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 10px;
  margin-bottom: 16px;
  padding: 20px;
  position: relative;

  &:focus-within {
    z-index: 10;
  }
`;

export const UpdateCardSectionHeader = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 16px;
  justify-content: space-between;
`;

export const UpdateCardSectionTitle = styled.h3`
  color: ${getColorFromTheme('blackTwo')};
  font: 600 16px/24px Graphik, sans-serif;
  margin: 0 0 4px;
`;

export const UpdateCardSectionSubtitle = styled.p`
  color: ${getColorFromTheme('textBody')};
  font: 400 13px/20px Graphik, sans-serif;
  margin: 0 0 18px;
`;

export const UpdateCardField = styled.div`
  margin-bottom: 16px;
  min-width: 0;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const UpdateCardFieldLabel = styled.div`
  color: ${getColorFromTheme('blackTwo')};
  font: 500 13px/20px Graphik, sans-serif;
  margin-bottom: 7px;
`;

export const UpdateCardSectionActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
`;

export const UpdateCardAddressSummary = styled.div`
  background: ${getColorFromTheme('backgroundLight')};
  border-radius: 8px;
  color: ${getColorFromTheme('blackTwo')};
  font: 500 14px/22px Graphik, sans-serif;
  padding: 12px;
  text-transform: capitalize;
`;

export const StripeCardField = styled.div`
  background: ${getColorFromTheme('white')};
  border: 1px solid ${getColorFromTheme('borderDark')};
  border-radius: 8px;
  min-height: 46px;
  padding: 14px 12px;

  &:focus-within {
    border-color: ${getColorFromTheme('purple300')};
    box-shadow: 0 0 0 3px rgba(88, 90, 223, 0.12);
  }
`;

export const SecurePaymentNote = styled.p`
  color: ${getColorFromTheme('textBody')};
  font: 400 12px/18px Graphik, sans-serif;
  margin: 10px 0 0;
`;

export const UpdateCardFooter = styled.footer`
  background: ${getColorFromTheme('white')};
  border-top: 1px solid ${getColorFromTheme('borderLight')};
  flex: 0 0 auto;
  padding: 16px 24px 24px;

  > button {
    width: 100%;
  }
`;
